import { createSlice } from "@reduxjs/toolkit";
import { NEW_ORDER_DATA, CANCELLED_ORDER_DATA, SHIPPED_ORDER_DATA } from "../../Data/Ecommerce";

const initialState = {
  proccessOrder: NEW_ORDER_DATA,
  shippedOrder: SHIPPED_ORDER_DATA,
  cancelledOrder: CANCELLED_ORDER_DATA,
};

const RecentOrderSlice = createSlice({
  name: "RecentOrderSlice",
  initialState,
  reducers: {
    setProccessOrder: (state, action) => {
      const newData = state.proccessOrder.filter((item) => item.id !== action.payload);
      state.proccessOrder = [...newData];
    },
    setShippedOrders: (state, action) => {
      const newData = state.shippedOrder.filter((item) => item.id !== action.payload);
      state.shippedOrder = [...newData];
    },
    setCancelledOrders: (state, action) => {
      const newData = state.cancelledOrder.filter((item) => item.id !== action.payload);
      state.cancelledOrder = [...newData];
    },
  },
});
export const { setProccessOrder, setShippedOrders, setCancelledOrders } = RecentOrderSlice.actions;

export default RecentOrderSlice.reducer;
